import * as React from 'react';

import logger from 'js/app/loggerSingleton';
import { useLocation } from 'js/lib/useRouter';

import ValuePropositionComponent from 'bundles/browse-common/components/ValuePropositionComponent';
import { usePageConfigComponentMetadata } from 'bundles/page-config-common/contexts/PageConfigComponentMetadataContext';
import useFacetCounts from 'bundles/search-common/hooks/useFacetCounts';
import { inferQueryFromParams } from 'bundles/search-common/utils/eventingUtils';
import {
  MEDIUM_INTENT_PARTNER_VALUE_COUNT,
  PARTNERS_MEDIUM_INTENT_PLACEHOLDER_ADDITIONAL_CONTENT,
} from 'bundles/search-common/utils/pageConfigUtils';

import _t from 'i18n!nls/search-common';

const getAdditionalContent = (courseCount?: number) => {
  const partnerCount = MEDIUM_INTENT_PARTNER_VALUE_COUNT;

  return [
    {
      value: partnerCount,
      category: _t('partners'),
    },
    {
      value: courseCount,
      category: _t('courses'),
    },
  ];
};

const PartnersMediumIntentSearchValuePropositionRenderer = () => {
  const query = inferQueryFromParams(useLocation().query.query);
  const context = usePageConfigComponentMetadata();

  const { courseCount, isLoading: loadingAdditionalContent } = useFacetCounts('productTypeDescription', {
    courseCount: 'Courses',
  });

  if (!context) {
    logger.warn('PartnersMediumIntentSearchValuePropositionRenderer expected PageConfigComponentMetadataProvider');
    return null;
  }

  const additionalContent = getAdditionalContent(courseCount);
  const { index } = context;

  return (
    <ValuePropositionComponent
      showPageTitleHeadingSize={index === 0}
      title={_t('Results for "#{query}"', { query })}
      additionalContent={
        loadingAdditionalContent ? PARTNERS_MEDIUM_INTENT_PLACEHOLDER_ADDITIONAL_CONTENT : additionalContent
      }
      isLoading={loadingAdditionalContent}
    />
  );
};

export default PartnersMediumIntentSearchValuePropositionRenderer;
